require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-government-shutdown-assistance.json") })
        }
      }, "path---articles-government-shutdown-assistance");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-government-shutdown-assistance!./.cache/json/articles-government-shutdown-assistance.json
// module id = 1695
// module chunks = 231608221292675